import {courseService} from '@jobseeker/common-core/services';
import {HiristArrowEnabled} from '@jobseeker/lotus/assets/icons';
import {Card, Carousel} from '@jobseeker/lotus/components';
import {Box, CardActionArea, IconButton, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {useEffect, useState} from 'react';
import {Course} from './types';
import {openCourseDetailPage} from './utils';

const TrendingCourses = () => {
  const [trendingCourses, setTrendingCourses] = useState<Course[]>([]);

  useEffect(() => {
    courseService
      .getTrendingCourses()
      .then((data: {CourseList: Course[]}) =>
        setTrendingCourses(data.CourseList)
      );
  }, []);

  return (
    <Box textAlign="center" mt={15} bgcolor="rgb(245, 244, 238)" py={10}>
      <Typography
        fontSize={20}
        fontWeight={600}
        sx={{
          textDecoration: 'underline #f59f4b',
        }}
        mb={5}
      >
        TRENDING COURSES
      </Typography>
      <Box display="flex" justifyContent="center">
        <IconButton
          className="previous-trending-courses"
          sx={{
            transform: 'rotate(180deg)',
            height: 'fit-content',
            position: 'relative',
            top: 125,
          }}
        >
          <Image
            src={HiristArrowEnabled}
            alt="previous-courses"
            height={57}
            width={57}
          />
        </IconButton>
        <Box maxWidth={1134} overflow="hidden">
          <Carousel
            carouselItems={trendingCourses.map(
              ({title, Location, logo, id}, idx) => (
                <Card
                  key={idx}
                  variant=""
                  heading={
                    <Box
                      onClick={() =>
                        openCourseDetailPage(title, id, {
                          refinv: 'lhome',
                          reforg: 'trendingcourses',
                        })
                      }
                      sx={{
                        cursor: 'pointer',
                      }}
                    >
                      <Image
                        src={logo}
                        alt="institute-logo"
                        height={85}
                        width={85}
                        style={{
                          marginTop: 24,
                        }}
                      />
                      <Box
                        component="hr"
                        position="relative"
                        left="-16px"
                        width="calc(100% + 32px)"
                        mb={0}
                      />
                    </Box>
                  }
                  sx={{
                    p: 0,
                    borderRadius: '2px',
                    border: '1px solid #e6e6e6',
                    width: 268,
                  }}
                >
                  <CardActionArea
                    sx={{
                      p: 2,
                      height: 195,
                    }}
                    onClick={() =>
                      openCourseDetailPage(title, id, {
                        refinv: 'lhome',
                        reforg: 'trendingcourses',
                      })
                    }
                  >
                    <Typography textAlign="left">{title}</Typography>
                    <Typography textAlign="left" fontSize={14} mt={2}>
                      {Location}
                    </Typography>
                  </CardActionArea>
                </Card>
              )
            )}
            next=".next-trending-courses"
            previous=".previous-trending-courses"
            breakpointOverrides={{
              1440: {slidesPerView: 4, spaceBetween: 30},
              1024: {slidesPerView: 4, spaceBetween: 30},
              375: {slidesPerView: 1, spaceBetween: 15},
              320: {slidesPerView: 1, spaceBetween: 9},
            }}
          />
        </Box>
        <IconButton
          className="next-trending-courses"
          sx={{height: 'fit-content', position: 'relative', top: 125}}
        >
          <Image
            src={HiristArrowEnabled}
            alt="next-courses"
            height={57}
            width={57}
          />
        </IconButton>
      </Box>
    </Box>
  );
};

export default TrendingCourses;
